module.exports = __webpack_public_path__ + "static/PMB_octopus_play-24c1a21bd2e12244bfd2c2238d53fd62.png";